import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables'

let _ = require('lodash')

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const ClientUser = {
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}external/profiles/admins/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}external/profiles/admins/${data._key}`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(_.omit(data, ['_id', '_key', '_rev'])),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  usersList: () => {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}external/profiles/admins/`, { headers }).then(handleErrors).then(handleResponse)
  },

  // getUser: key => {
  //   headers['Authorization'] =
  //     'token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJzZXNzaW9ucy8zMzY3MTAwNzgxMjk5IiwiX2tleSI6IjMzNjcxMDA3ODEyOTkiLCJfcmV2IjoiX1gxeW9SbFMtLUIiLCJpYXQiOjE1NDM5OTMxODMsImV4cCI6MzYwMTU0Mzk4OTU4M30.DPy5M9QZ78_rmq2NFbL5A0Vhk1fmpxEpo-x1XugAbI8'
  //
  //   return fetch(`${ClientUrl}/profiles/admins/${key}`, {
  //     headers: headers,
  //   })
  //     .then(handleErrors)
  //     .then(handleResponse)
  // },

  listClients: () => {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}clients/`, { headers }).then(handleErrors).then(handleResponse)
  },
}
